import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { ICreateRequest } from 'interfaces/create-duck';
import { requestErrorHandler } from 'utils';
import { ImportClientsActions } from 'store/ducks/settings/clients';

export function* importClientsRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/clients/import-sequence`,
      postData
    );

    const { data } = responseBody;
    yield put(ImportClientsActions.success(data));
    notify('success', `Importação concluída com sucesso.
      Sucesso: ${responseBody?.success || 0}
      Falha: ${responseBody?.failed || 0}
      Total: ${responseBody?.total || 0}
      `);
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(ImportClientsActions.failure(errorMessage));
  }
}

